module.exports = __webpack_public_path__ + "static/media/Calibre-RegularItalic.35657aa2.woff2";